import React from 'react'
import { Grid } from '@mui/material'

import PageWrapper from 'Pages/@PageWrapper'
import { TourProvider, TourTarget } from "@tour"
import { CUSTOM_DASHBOARD_ROUTES } from '@constants/routes'
import {isSystemBusy} from "@signals";
import AmazonPPKpisFilters from "./Filters";
import {amazonPPKpisIsEmpty} from "./@signals";
import AmazonReleaseDateTable from "./Table";

export default function AmazonPPKpisPage() {

    const props = {
        head: CUSTOM_DASHBOARD_ROUTES.AMAZON_PP_KPIS_TITLE,
        title: CUSTOM_DASHBOARD_ROUTES.AMAZON_PP_KPIS_TITLE,
        subtitle: CUSTOM_DASHBOARD_ROUTES.AMAZON_PP_KPIS_SUBTITLE,
        isEmpty: amazonPPKpisIsEmpty.value,
        hasErrors: isSystemBusy.value,
        tourPageKey: "amazonPPKpis"
    }

    return <PageWrapper {...props} filters={<AmazonPPKpisFilters/>}>
        <Grid container spacing={2}>
            <Grid item xs={12} sx={{ position: "relative" }}>
                <TourTarget name="amazon-pp-kpis-table" height={350} />
                <AmazonReleaseDateTable />
            </Grid>
        </Grid>
    </PageWrapper>
}